import { post } from '@/httpRequest'

export const postTransactionConfirm = async (id: string, method: string) => {
  const response = await post<null>(`/ink/transaction/confirm/${id}`, {
    payment_method: method
  })
  return response
}
